import { useCallback, useMemo, useState } from "react";

import {
  formatMissingWorklogLabel,
  getMissingWorklogDayName,
  getMissingWorklogHours,
} from "../utils/worklogMissingUtils";

export function useMissingItemState(worklog, dailyWorklogHours) {
  const [dialog, setDialog] = useState(false);

  const missingHours = useMemo(
    () => getMissingWorklogHours(dailyWorklogHours, worklog?.total_hours_spent),
    [dailyWorklogHours, worklog?.total_hours_spent]
  );

  const dayName = useMemo(
    () => getMissingWorklogDayName(worklog.date),
    [worklog.date]
  );

  const label = useMemo(
    () => formatMissingWorklogLabel(worklog.date, missingHours),
    [missingHours, worklog.date]
  );

  const handleClose = useCallback(() => {
    setDialog(false);
  }, []);

  const handleOpen = useCallback(() => {
    setDialog(true);
  }, []);

  return {
    dayName,
    dialog,
    handleClose,
    handleOpen,
    label,
    missingHours,
  };
}
